<template>
    <div>
        <el-collapse v-model="requireComIds" @change="handleChange">
            <el-collapse-item :name="goodsItem.requireComId" v-for="(goodsItem, index) in goodsItems">
                <template slot="title">
                    <div class="inline-block ml5">
                        <span class="mr5">请购机构：</span>
                        <span>{{goodsItem.requireComName || "无"}}</span>
                    </div>
                </template>
                <div class="table-layout">
                    <el-table :data="goodsItem.goodsItemList" style="width: 100%" border :row-class-name="getRowClass" :expand-row-keys="expends" :row-key="getRowKeys" @expand-change="showManageDetail">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <div class="sub-table-layout pr10 pl10">
                                    <el-table :data="props.row.itemList" border style="width: 100%">
                                        <el-table-column prop="name" label="名称" width="150"></el-table-column>
                                        <el-table-column prop="goodsCatName" label="分类名称" width="150"></el-table-column>
                                        <el-table-column prop="goodsBrandName" label="品牌名称" width="100"></el-table-column>
                                        <el-table-column prop="model" label="型号" width="100"></el-table-column>
                                        <el-table-column prop="fixedSpec" label="规格" width="100"></el-table-column>
                                        <el-table-column prop="unit" label="单位" width="80"></el-table-column>
                                        <el-table-column prop="vendorName" label="供应商" width="150"></el-table-column>
                                        <el-table-column label="合同名称" prop="contractTitle"></el-table-column>
                                        <el-table-column label="含税价(元)" prop="price">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.price != null">{{scope.row.price.toFixed(2)}}</span>
                                                <span v-else>0.00</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="税率(%)" prop="taxRate">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.taxRate != null">{{scope.row.taxRate.toFixed(2)}}</span>
                                                <span v-else>0.00</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="未税价(元)" prop="ntxPrice">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.ntxPrice != null">{{scope.row.ntxPrice.toFixed(2)}}</span>
                                                <span v-else>0.00</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="请求数量" align="right" width="80">
                                            <template slot-scope="scope">
                                                <el-input type="text" v-model.number="scope.row.quantity" @change="accQuantity(scope.$index,props.$index,index)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="desc" label="描述"></el-table-column>
                                        <el-table-column align="left" label="操作" width="200">
                                            <template slot-scope="scope">
                                                <a class="swb-btn-link" @click="removeAccGoods(scope.$index,props.$index,index)">移除</a>
                                                <a class="swb-btn-link" v-if="scope.row.skuId == null || scope.row.skuId == -1" @click="selectAdoptedGoods(scope.$index,props.$index, index)">关联商品</a>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="名称" prop="name"></el-table-column>
                        <el-table-column label="分类名称" prop="goodsCatName"></el-table-column>
                        <el-table-column label="品牌名称" prop="goodsBrandName"></el-table-column>
                        <el-table-column label="型号" prop="model"></el-table-column>
                        <el-table-column label="规格" prop="fixedSpec"></el-table-column>
                        <el-table-column label="供应商" prop="vendorName"></el-table-column>
                        <el-table-column label="合同名称" prop="contractTitle"></el-table-column>
                        <el-table-column label="仅组装件" v-if="!lowCostFlag" align="center" prop="onlyForAsmblAcc">
                            <template slot-scope="scope">
                                <input type="checkbox" v-model="scope.row.onlyForAsmblAcc" @change="onlyForAsmblAccChange(scope.$index,scope.row.onlyForAsmblAcc,index)"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="采购模式" align="center" prop="centBuyMode">
                            <template slot-scope="scope">
                            <span v-if="scope.row.onlyForAsmblAcc">
                                <el-select v-model="scope.row.centBuyMode" placeholder="请选择" @change="selectCentBuyMode(scope.$index, index)">
                                    <el-option v-for="item in centBuyModeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </span>
                                <span v-else>
                                <span v-if="scope.row.centBuyMode">集采</span>
                                <span v-else>自采</span>
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="设置组装件数量" v-if="!lowCostFlag" align="right" prop="asmblAccSetCount"></el-table-column>
                        <el-table-column label="含税价(元)" prop="price">
                            <template slot-scope="scope">
                                <span v-if="scope.row.price != null">{{scope.row.price.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="税率(%)" prop="taxRate">
                            <template slot-scope="scope">
                                <span v-if="scope.row.taxRate != null">{{scope.row.taxRate.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="未税价(元)" prop="ntxPrice">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ntxPrice != null">{{scope.row.ntxPrice.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="申请数量" align="right">
                            <template slot-scope="scope">
                                <el-input type="text" v-model.number="scope.row.quantity" :disabled="scope.row.onlyForAsmblAcc" @change="goodsQuantity(scope.$index,scope.row.quantity, index)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" label="操作">
                            <template slot-scope="scope">
                                <a class="swb-btn-link" @click="removeGoods(scope.$index,index)">移除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import devcReqrApi from '../../api/devcReqr'
    import devcDefApi from '../../api/devcDef'
    import { goodsInSelectDlg, servcInSelectDlg } from './dialog'
    import { openVendorSelectComnDlg } from '../vendor/selectDlg'
    import { openSkuListSelectDlg } from '../goods/selectDlg'
    import { showAsmblAccDefSelectDlg } from '../asmblAcc/dialog'
    import retailerApi from '../../api/retailer'

    export default {
        name: 'swb-device-require-voucher-other-vendor',
        desc: '设备请购单项列表',
        props: {
            itemFilter: {
                type: Object,
                default: null
            },
            lowCostFlag: {
                type: Boolean,
                default: false,
            }
        },
        data: function () {
            return {
                goodsItemMap: {
                    goodsItemList: [],
                    requireComName: null,
                },
                requireComIds: [],
                goodsItems: [],
                expends: [],
                centBuyModeList: [{"value": true, text: '集采'}, {"value": false, text: "自采"}],
            }
        },
        watch: {
            itemFilter: function (newVal, oldVal) {
                this.getRequireGoodsItem();
            },
        },
        created: function () {
            this.getRequireGoodsItem();
        },
        methods: {
            handleChange(val) {
            },
            getRowClass(row, rowIndex){
                if(Utils.isNoB(row.row.itemList) || row.row.itemList.length == 0) {  //判断当前行是否有子数据或者根据实际情况设置
                    return 'row-expand-cover'
                }
            },
            getExpends(){
                let deviceIds = this.expends || [];
                let goodsItemList = this.goodsItemList || [];
                goodsItemList.forEach(function (item) {
                    if(!Utils.isNoB(item.itemList) && item.itemList != null && item.itemList.length > 0) {
                        deviceIds.push(item.deviceId);
                    }
                });
                this.expends = Utils.merge([], deviceIds);
            },
            showManageDetail(row){
                let deviceId = row.deviceId;
                let expends = this.expends || [];
                if(expends.indexOf(deviceId) > -1) {
                    expends.remove(deviceId);
                } else {
                    expends.push(deviceId);
                }
                this.expends = Utils.merge([], expends);
            },
            getRowKeys(row){
                return row.deviceId
            },
            getRequireGoodsItem: function () {
                let self = this;
                let itemFilter = self.itemFilter || {};
                let asmblList = Utils.merge([], itemFilter.asmblItemList);
                let requireComIds = [];
                let asmblItemMap = {};
                let requireComMap = {}
                for(let i = 0; i < asmblList.length; i++) {
                    let asmbl = asmblList[i];
                    if(Utils.isNoB(asmblItemMap[asmbl.requireComId])) {
                        let goodsAsmblItemList = [];
                        goodsAsmblItemList.push(asmbl);
                        asmblItemMap[asmbl.requireComId] = goodsAsmblItemList;
                        requireComMap[asmbl.requireComId] = asmbl.requireComName;
                        requireComIds.push(asmbl.requireComId)
                    } else {
                        let goodsAsmblItems = asmblItemMap[asmbl.requireComId] || [];
                        goodsAsmblItems.push(asmbl);
                        asmblItemMap[asmbl.requireComId] = goodsAsmblItems;
                    }
                }
                let goodsItemMap = {};
                let itemList = Utils.merge([], itemFilter.goodsItemList);
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(Utils.isNoB(goodsItemMap[item.requireComId])) {
                        let goodsAsmblItemList = [];
                        goodsAsmblItemList.push(item);
                        goodsItemMap[item.requireComId] = goodsAsmblItemList;
                        requireComMap[item.requireComId] = item.requireComName;
                        requireComIds.push(item.requireComId);
                    } else {
                        let goodsAsmblItems = goodsItemMap[item.requireComId] || [];
                        goodsAsmblItems.push(item);
                        goodsItemMap[item.requireComId] = goodsAsmblItems;
                    }
                }
                let goodsItems = [];
                for(let i = 0; i < requireComIds.length; i++) {
                    let goodsItem = {};
                    let itemList = [];
                    let requireComId = requireComIds[i];
                    if(!Utils.isNoB(asmblItemMap[requireComId])) {
                        for(let j = 0; j < asmblItemMap[requireComId].length; j++) {
                            let item = asmblItemMap[requireComId][j];
                            item.asmblAccFlag = true;
                            itemList.push(item);
                        }
                    }
                    if(!Utils.isNoB(goodsItemMap[requireComId])) {
                        for(let j = 0; j < goodsItemMap[requireComId].length; j++) {
                            let item = goodsItemMap[requireComId][j];
                            item.asmblAccFlag = false;
                            itemList.push(item);
                        }
                    }
                    if(!Utils.isNoB(requireComMap[requireComId])) {
                        goodsItem.requireComName = requireComMap[requireComId];
                    }
                    goodsItem.goodsItemList = itemList;
                    goodsItem.requireComId = requireComId;
                    goodsItems.push(goodsItem)
                }
                self.goodsItems = Utils.merge([], goodsItems);
                self.requireComIds = Utils.merge([], requireComIds);
                self.goodsItemList = Utils.merge([], asmblList.concat(itemList));
                self.getExpends();
            },

            validateQuantity: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入申请数量'));
                } else {
                    if(!Utils.isNumber(value) || value <= 0) {
                        callback(new Error('请输入大于0的数字'));
                    } else {
                        callback();
                    }
                }
            },
            removeGoods: function (index, topIndex) {
                let self = this;
                let expends = self.expends || [];
                let topGoodsItem = self.goodsItems[topIndex];
                let goodsItemList = topGoodsItem.goodsItemList;
                this.$confirm('确定删除此商品?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {

                    let goodsItem = goodsItemList[index];
                    goodsItemList.splice(index, 1);
                    if(expends.indexOf(goodsItem.deviceId) > -1) {
                        expends.remove(goodsItem.deviceId);
                    }
                    self.expends = Utils.merge([], expends);
                    self.goodsItemList = Utils.merge([], goodsItemList);
                }).catch(function () {
                });
            },
            // 入选商品的数量修改
            goodsQuantity: function (index, quantity, topIndex) {
                let topGoodsItem = this.goodsItems[topIndex];
                let goodsItemList = topGoodsItem.goodsItemList;
                let goodsItem = goodsItemList[index];
                if(!Utils.isNumber(quantity) || quantity <= 0) {
                    MsgBox.warning('请输入大于0的数字');
                    return;
                }
                let itemList = goodsItem.itemList || [];
                let asmblAccSetCount = 0;
                let asmblAccReqCount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(!Utils.isNoB(item.quantity)) {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                        asmblAccReqCount = parseInt(asmblAccReqCount) + item.quantity;
                    }
                }
                goodsItem.asmblAccSetCount = asmblAccSetCount;
                goodsItem.asmblAccReqCount = asmblAccReqCount;
                this.goodsItemList = Utils.merge([], goodsItemList);
            },
            // 组装件数量修改
            accQuantity: function (index, goodsIndex, topIndex) {
                let topGoodsItem = this.goodsItems[topIndex];
                let goodsItemList = topGoodsItem.goodsItemList;
                let goodsItem = goodsItemList[goodsIndex];
                let itemList = goodsItem.itemList || [];
                let item = itemList[index];
                if(!Utils.isNumber(item.quantity) || item.quantity <= 0) {
                    MsgBox.warning('请输入大于0的数字');
                    return;
                }
                let asmblAccSetCount = 0;
                let asmblAccReqCount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(!Utils.isNoB(item.quantity)) {
                        if(Utils.isTrue(goodsItem.onlyForAsmblAcc)) {
                            asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                            asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                        } else {
                            asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                            asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                        }
                    }

                }
                goodsItem.asmblAccSetCount = asmblAccSetCount;
                goodsItem.asmblAccReqCount = asmblAccReqCount;
                this.goodsItemList = Utils.merge([], goodsItemList);
            },
            selectAdoptedGoods: function (index, goodsIndex, topIndex) {
                let self = this;
                let topGoodsItem = self.goodsItems[topIndex];
                let goodsItemList = topGoodsItem.goodsItemList || [];
                let goodsItem = goodsItemList[goodsIndex];
                let itemList = goodsItem.itemList;
                let item = itemList[index];
                let bizAreaId = self.bizAreaId != null ? self.bizAreaId : -1;
                let bizFormId = self.bizFormId != null ? self.bizFormId : -1;
                let filter = {
                    asmblAccFlag: true,
                    bizAreaId: bizAreaId,
                    bizFormId: bizFormId,
                    bizAreaFlag: true,
                    bizFormFlag: true,
                    catId: item.goodsCatId,
                    brandId: item.goodsBrandId,
                    goodsModel: item.model,
                    disabled: false
                };
                let params = {};
                params.filter = filter;
                params.skuFlag = true;
                params.checkBox = false;
                params.showTable = true;
                params.showCatBrandTable = true;
                params.showCatBrandModelTable = true;
                params.showAccFlag = true;
                goodsInSelectDlg(params, function (result) {
                    item.deviceId = result.id;
                    item.name = result.name;
                    item.asmblAccFlag = result.asmblAccFlag;
                    item.centBuyMode = result.centBuyMode;
                    item.skuId = result.skuId;
                    item.title = result.title;
                    item.bizAreaCode = result.bizAreaCode;
                    item.bizFormCode = result.bizFormCode;
                    item.vendorName = result.vendorName;
                    item.vendorId = result.vendorId;
                    if(Utils.isTrue(result.contractEnded)) {
                        item.contractId = -1;
                    } else {
                        item.contractTitle = result.contractTitle;
                        item.contractId = result.contractId;
                        item.contractDateStart = result.contractDateStart;
                        item.contractDateEnd = result.contractDateEnd;
                    }
                    item.model = result.model;
                    item.fixedSpec = result.fixedSpec;
                    item.modelSpec = result.modelSpec;
                    item.price = result.price;
                    item.ntxPrice = result.ntxPrice;
                    item.taxRate = result.taxRate;
                    item.wrntPeriod = result.wrntPeriod;
                    item.arriveDays = result.arriveDays;
                    item.goodsCatName = result.goodsCatName;
                    item.goodsBrandName = result.goodsBrandName;
                    item.unit = result.unit;
                    goodsItem.itemList = Utils.merge([], itemList);
                    self.goodsItemList = Utils.merge([], goodsItemList);
                });
            },
            // 是否只有组装件
            onlyForAsmblAccChange(index, onlyForAsmblAcc){
                let goodsItemList = this.goodsItemList;
                let goodsItem = goodsItemList[index];
                let itemList = goodsItem.itemList;
                goodsItem.quantity = null;
                let asmblAccSetCount = 0;
                let asmblAccReqCount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(!Utils.isNoB(item.quantity)) {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                        asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                    }
                }
                goodsItem.centBuyMode = goodsItem.reqCentBuyMode;
                goodsItem.asmblAccSetCount = asmblAccSetCount;
                goodsItem.asmblAccReqCount = asmblAccReqCount;
                this.goodsItemList = Utils.merge([], goodsItemList);
            },
            // 删除入选商品的组装件
            removeAccGoods(index, goodsIndex, topIndex){
                let topGoodsItem = this.goodsItems[topIndex];
                let goodsItemList = topGoodsItem.goodsItemList;
                let goodsItem = goodsItemList[goodsIndex];
                let itemList = goodsItem.itemList;
                itemList.splice(index, 1);
                if(itemList.length <= 0) {
                    let expends = this.expends || [];
                    if(expends.indexOf(goodsItem.deviceId) > -1) {
                        expends.remove(goodsItem.deviceId);
                    } else {
                        expends.push(goodsItem.deviceId);
                    }
                    this.expends = Utils.merge([], expends);
                }
                let asmblAccSetCount = 0;
                let asmblAccReqCount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(Utils.isTrue(goodsItem.onlyForAsmblAcc)) {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                        asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                    } else {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + (parseInt(item.quantity) * parseInt(goodsItem.quantity));
                        asmblAccReqCount = parseInt(asmblAccReqCount) + (parseInt(item.reqQuantity) * parseInt(goodsItem.quantity));
                    }
                }
                goodsItem.asmblAccSetCount = asmblAccSetCount;
                goodsItem.asmblAccReqCount = asmblAccReqCount;
                goodsItem.itemList = Utils.merge([], itemList);
                this.goodsItemList = Utils.merge({}, goodsItemList);
                this.$emit('notity-change-goods', goodsItemList);
            },
            getContractGoodsItem(vendorId, skuId, contractId, callBack){
                let bizFormId = this.bizFormId != null ? this.bizFormId : -1;
                let bizAreaId = this.bizAreaId != null ? this.bizAreaId : -1;
                let postData = {
                    vendorId: vendorId,
                    skuId: skuId,
                    bizAreaId: bizAreaId,
                    bizFormId: bizFormId,
                    contractId: contractId,
                };
                devcReqrApi.getContractGoodsItem(postData, function (result) {
                    if(result.type == "info") {
                        callBack(result.data);
                    } else {
                        callBack(null);
                    }
                })
            },
            getDlgResult: function () {
                let result = {};
                //
                let itemList = this.goodsItems || [];
                let asmblItemList = [];
                let goodsItemList = [];
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(Utils.isTrue(item.asmblAccFlag)) {
                        for(let j = 0; j < item.goodsItemList.length; j++) {
                            let goodsItem = item.goodsItemList[j];
                            asmblItemList.push(goodsItem);
                        }
                    } else {
                        for(let j = 0; j < item.goodsItemList.length; j++) {
                            let goodsItem = item.goodsItemList[j];
                            goodsItemList.push(goodsItem);
                        }
                    }
                }

                result.data = {
                    goodsItemList: goodsItemList,
                    asmblItemList: asmblItemList
                };

                result.type = "info";
                return result;
            },
            selectCentBuyMode: function (index, topIndex) {
                let topGoodsItem = this.goodsItems[topIndex];
                let goodsItemList = topGoodsItem.goodsItemList;
                let goodsItem = goodsItemList[index];
                let itemList = goodsItem.itemList || [];
                itemList.forEach(function (item) {
                    item.centBuyMode = goodsItem.centBuyMode;
                });
                goodsItem.itemList = Utils.merge([], itemList);
                this.goodsItemList = Utils.merge([], goodsItemList);
            },
        }
    }
</script>
<style>
    .el-table .row-expand-cover .cell .el-table__expand-icon {
        display: none;
    }
</style>




// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireVoucherOtherVoucher.vue